import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const createAssignmentsReducer = ({
    USER_WORK_ASSIGNMENTS = {},
    USER_MANAGEMENT_ASSIGNMENTS = {},
    USER_TEAM_ASSIGNMENTS = {}
}) => {
    const initialState = {
        userWorkAssignments: USER_WORK_ASSIGNMENTS,
        userManagementAssignments: USER_MANAGEMENT_ASSIGNMENTS,
        userTeamAssignments: USER_TEAM_ASSIGNMENTS
    }

    return handleActions({
        [ActionTypes.USER_WORK_ASSIGNMENTS_ADD]: (state, {payload: {userId, all, customers, projects, tasks}}) => ({
            ...state,
            userWorkAssignments: {
                ...state.userWorkAssignments,
                [userId]: {
                    all,
                    customers,
                    projects,
                    tasks
                }
            }
        }),
        [ActionTypes.USER_MANAGEMENT_ASSIGNMENTS_ADD]: (state, {payload: {userId, all, customers, projects, tasks}}) => ({
            ...state,
            userManagementAssignments: {
                ...state.userManagementAssignments,
                [userId]: {
                    all,
                    customers,
                    projects,
                    tasks
                }
            }
        }),
        [ActionTypes.USER_TEAM_ASSIGNMENTS_ADD]: (state, {payload: {userId, all, groupIds}}) => ({
            ...state,
            userTeamAssignments: {
                ...state.userTeamAssignments,
                [userId]: {
                    all,
                    groupIds
                }
            }
        })
    }, initialState)
}

export default createAssignmentsReducer



// WEBPACK FOOTER //
// ./web/js/assignments/reducer.js